import { render } from "./Address.vue?vue&type=template&id=9035c372&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=9035c372&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9035c372"]])

export default __exports__